import React from 'react';
import { Plus } from 'lucide-react';
import { FAQS } from '../data/seo';
import { STUDIO } from '../data/studio';

/**
 * The questions a first-time visitor asks before they are willing to message a
 * stranger about a wedding blouse. It earns its place twice over: the same
 * answers are emitted as FAQPage structured data by scripts/build_seo.mjs, and
 * answer engines quote them close to verbatim.
 *
 * Native <details>/<summary>, not a hand-rolled accordion — it is keyboard
 * operable, findable by in-page search when collapsed in current browsers, and
 * readable by a crawler that runs no JavaScript.
 */
export default function Faq({ onOpenQuote }) {
  return (
    <section
      id="questions"
      aria-labelledby="questions-heading"
      className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8"
    >
      <div className="max-w-5xl mx-auto grid gap-10 lg:grid-cols-[minmax(0,22rem)_1fr] lg:gap-16 lg:items-start">

        <div className="lg:sticky lg:top-28 space-y-4">
          <span className="text-[11px] uppercase tracking-[0.22em] text-[#7F6055] font-bold block">
            Before you write
          </span>
          <h2
            id="questions-heading"
            className="text-3xl sm:text-4xl lg:text-[44px] font-90s font-black text-[#4E2C23] tracking-tight leading-[1.05]"
          >
            Questions
          </h2>
          <p className="text-sm text-[#745147] leading-relaxed">
            Anything not answered here, ask directly — the studio would rather
            talk it through than have you guess.
          </p>
          <button
            onClick={onOpenQuote}
            className="btn-burnt-peach px-5 py-2.5 text-xs font-bold uppercase tracking-wider"
          >
            Start an Order
          </button>
        </div>

        <div className="divide-y divide-[#4E2C23]/12 border-y border-[#4E2C23]/12">
          {FAQS.map((item) => (
            <details key={item.q} className="group py-1">
              <summary className="faq-summary flex items-start justify-between gap-4 py-4 cursor-pointer">
                <h3 className="font-90s font-bold text-[#4E2C23] text-base sm:text-lg leading-snug">
                  {item.q}
                </h3>
                <Plus
                  className="w-5 h-5 mt-0.5 flex-shrink-0 text-[#E2725B] transition-transform duration-300 group-open:rotate-45"
                  strokeWidth={2}
                  aria-hidden="true"
                />
              </summary>
              <p className="pb-5 pr-9 text-sm text-[#745147] leading-relaxed">
                {item.a}
              </p>
            </details>
          ))}
        </div>
      </div>

      <p className="max-w-5xl mx-auto mt-8 text-sm text-[#745147]">
        Still deciding?{' '}
        <a
          href={`https://wa.me/${STUDIO.phone}`}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#B84D37] underline underline-offset-4 decoration-[#E2725B]/40 hover:decoration-[#E2725B]"
        >
          Message the studio on WhatsApp
        </a>
        .
      </p>
    </section>
  );
}
